

          
          
          window.Fandango.templates = window.Fandango.templates || {};
          window.Fandango.templates._errorMessage = function anonymous(_swig,_ctx,_filters,_utils,_fn
) {
  var _imports = {  };
  var _ext = _swig.extensions,
    _output = "";
_output += "<span class=\"error-msg\">";
_output += _filters["e"]((((typeof _ctx.msg !== "undefined" && _ctx.msg !== null) ? ((typeof _ctx.msg !== "undefined" && _ctx.msg !== null) ? _ctx.msg : "") : ((typeof msg !== "undefined" && msg !== null) ? msg : "")) !== null ? ((typeof _ctx.msg !== "undefined" && _ctx.msg !== null) ? ((typeof _ctx.msg !== "undefined" && _ctx.msg !== null) ? _ctx.msg : "") : ((typeof msg !== "undefined" && msg !== null) ? msg : "")) : "" ));
_output += "</span>";

  return _output;

}
          export default window.Fandango.templates._errorMessage;
          